import { Apollo } from 'apollo-angular';
import { Injectable } from '@angular/core';

import { ApolloErrorHandler } from 'app/shared/apollo';

import { GlobalService } from '../../../shared/global/index';

import { CompanySuperService } from '../company.super.service';

@Injectable()
export class CompanySingleProjectService extends CompanySuperService {
  dataModel = 'project';

  constructor(apollo: Apollo, apolloErrorHandler: ApolloErrorHandler) {
    super(apollo, apolloErrorHandler);
  }

  dataFormater(data, mode) {
    let dataSetFormatted;

    switch (mode) {
      case 'labels':
        dataSetFormatted = this.makeLabelsArray(data);
        break;
      case 'list':
        dataSetFormatted = this.makeObjectsForForms(data);
        break;
      case 'stripNode':
        dataSetFormatted = this.stripFromNode(data);
        break;
    }

    return dataSetFormatted;
  }

  stripFromNode(data) {
    const dataObject = data.project;
    const dataObjectWithoutNode = { ...dataObject };

    return dataObjectWithoutNode;
  }

  makeLabelsArray(data) {
    const dataArray = data.company[this.dataModel + 's'].edges;
    const dataObjectsWithLabels = [];

    dataObjectsWithLabels.push({ label: 'Visa alla projekt', value: null });

    for (const i in dataArray) {
      const dataObject = {
        label: dataArray[i].node.trueId + ', ' + dataArray[i].node.mark,
        value: dataArray[i].node.id,
      };
      dataObjectsWithLabels.push(dataObject);
    }
    return dataObjectsWithLabels;
  }

  makeObjectsForForms(data) {
    const dataArray = data.company[this.dataModel + 's'].edges;
    const dataObjectsForForms = [];

    for (const i in dataArray) {
      const projectInfo =
        dataArray[i]['node']['trueId'] + ', ' + dataArray[i]['node']['mark'];

      const dataObject = { ...dataArray[i].node };

      if (dataObject['extra'] == null) {
        dataObject['extraText'] = 'Nej';
      } else {
        dataObject['extraText'] = 'Ja';
      }
      dataObject['projectInfo'] = projectInfo;
      dataObjectsForForms.push(dataObject);
    }
    return dataObjectsForForms;
  }
}
